module.exports = __webpack_public_path__ + "static/media/profile.2d4b20e5.svg";